import React, { useEffect, useState } from 'react';
import {
    Routes,
    Route,
    useLocation
} from "react-router-dom";
import Minibar from '../../../components/navbar/Minibar';
import StandingAlarmPage from './StandingAlarm';
import HistoricalAlarmPage from './HistoricalAlarm';

function Document(props) {
    const location = useLocation();
    const [submenu_root, setSubmenu_root] = useState('Realtime A & E');

    useEffect(() => {
        if (location.pathname.search("/alarmevent/realtimeae") > -1) {
            setSubmenu_root('Realtime A & E')
        }
        if (location.pathname.search("/alarmevent/standingalarm") > -1) {
            setSubmenu_root('Standing Alarm')
        }
        if (location.pathname.search("/alarmevent/historicalae") > -1) {
            setSubmenu_root('Historical A & E')
        }
    }, [location]);

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Alarm & Event System"}
                submenu_root={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0">
                    <Routes>
                        <Route path="/realtimeae" element={
                            <StandingAlarmPage
                                systemtime={props.data_systemdatetime}
                                server_update={props.server_update}
                                permitdata={props.permitdata}
                                center_hot_update={props.center_hot_update}
                                callback_select_site={(sitecode, sitename_en, sitename_th, api_url, back_url) => { props.callback_select_site(sitecode, sitename_en, sitename_th, api_url, back_url) }}
                            ></StandingAlarmPage >} />
                        <Route path="/historicalae" element={
                            <HistoricalAlarmPage
                                systemtime={props.data_systemdatetime}
                                permitdata={props.permitdata}
                            ></HistoricalAlarmPage >} />
                    </Routes>
                </div>
            </div>
        </section>

    )
}
export default Document